// src/hooks/useAuthValidation.js
import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";

export const useAuthValidation = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthValidation deve ser usado dentro de AuthProvider");
  }
  return context;
};
